import { render, staticRenderFns } from "./ManageLandingPage.vue?vue&type=template&id=4cbc2381&scoped=true&"
import script from "./ManageLandingPage.vue?vue&type=script&lang=js&"
export * from "./ManageLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc2381",
  null
  
)

export default component.exports